import { useEffect } from "react"
import { Box } from "@mui/material"
import useAppStore from "store/app"

import ProgressBar from "./ProgressBar"
import Symptoms from "./Symptoms"
import Correction from "./Correction"
import PersonalInfo from "./PersonalInfo"
import CommonQuestions from "./CommonQuestions"
import CloseButton from "components/shared/buttons/CloseButton"
import Screening from "../Screening"
import Empty from "./Result/Empty"
import useTranslation from "../../../hooks/use_translation"

const Anamnesis = () => {
  const { currentStep } = useAppStore((state) => state.anamnesis)

  const { anamnesis } = useTranslation()

  const steps = [
    anamnesis?.step1_title,
    anamnesis?.step2_title,
    anamnesis?.step3_title,
    anamnesis?.step4_title,
    anamnesis?.step5_title,
  ]

  const currentAnamnesis = useAppStore((state) => state.anamnesis.uuid)
  const { empty_result } = useAppStore((state) => state.anamnesis)
  const createAnamnesis = useAppStore((state) => state.createAnamnesis)
  const toggleDrawer = useAppStore((state) => state.toggleDrawer)

  const resetState = () => {}

  useEffect(() => {
    if (!currentAnamnesis?.length) {
      createAnamnesis()
    } else {
      console.log("Anamnesis:", currentAnamnesis)
    }

    return toggleDrawer(false)
  }, [])

  return (
    <Box sx={{ mt: 2, mb: 10 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <ProgressBar steps={steps} currentStep={currentStep} />
        <CloseButton callback={resetState} redirect_to="/me" />
      </Box>

      {currentStep === 0 && <PersonalInfo />}
      {currentStep === 1 && <CommonQuestions />}
      {currentStep === 2 && <Symptoms />}
      {currentStep === 3 && <Correction />}
      {currentStep === 4 && empty_result && <Empty />}
      {currentStep === 4 && !empty_result && <Screening screening_id={currentAnamnesis} />}
    </Box>
  )
}

export default Anamnesis
